<script>
  import { ShopboxCreateClient } from '@shopboxai/sb-create-client-app';
  import { currentUser } from '../stores';
</script>

<ShopboxCreateClient user={$currentUser} />
